import React, { useEffect } from "react";
import Icon from "../doctor-console/Utils/Icons";
import { useHistory, useLocation } from "react-router-dom";
import "./BillingPayment.scss";

const SideNavbar = ({ children }) => {
  const history = useHistory();
  const location = useLocation();

  const handleSectionClick = (section) => {
    if (section?.onClick) {
      section.onClick();
      return;
    }
    const destination = section?.route || `/doctor/${section.label.toLowerCase()}`;
    history.push(destination);
  };

  useEffect(() => {
    if (
      sessionStorage.getItem("accessToken") === undefined ||
      sessionStorage.getItem("accessToken") === null
    ) {
      history.push("/login");
    }
  }, [history]);

  const sections = [
    {
      label: "Item",
      displayLabel: "Available Services",
      icon: <Icon name="availableServices" size={26} />,
      iconWhite: <Icon name="availableServicesWhite" size={26} />,
    },
    {
      label: "Invoice",
      displayLabel: "Billing Invoices",
      icon: <Icon name="billingInvoices" size={26} />,
      iconWhite: <Icon name="billingInvoicesWhite" size={26} />,
    },
    {
      label: "Estimates",
      displayLabel: "Estimates",
      icon: <Icon name="costEstimates" size={26} />,
      iconWhite: <Icon name="costEstimatesWhite" size={26} />,
      route: "/doctor/estimates",
    },
    {
      label: "Refund",
      displayLabel: "Refund",
      icon: <Icon name="paymentDetails" size={26} />,
      iconWhite: <Icon name="paymentDetailsWhite" size={26} />,
      route: "/doctor/refund",
    },
  ];

  return (
    <div className="top-cards-layout">
      <header className="top-cards-header">
        <div className="scroll-container">

          {/* {isSmallScreen && (
          <div style={{ display: 'flex', alignItems: 'center', marginBottom: '7.5px', marginRight: '7.5px', marginLeft: '7.5px' }}>
            <button
              className="scroll-arrow left"
              id="leftArrow"
              style={{
                position: 'relative',
                top: '0',
                transform: 'none',
                background: '#ffffff',
                color: '#808285',
                border: 'none',
                padding: '10px',
                cursor: 'pointer',
                zIndex: '1',
                borderRadius: '5px',
                fontSize: '18px',
                boxShadow: '0px 4px 4px 0px #0000004D',
                marginRight: '10px',
                opacity: '0.5',
                pointerEvents: 'none'
              }}
              onClick={() => {
                const container = document.querySelector('.cards-row');
                container.scrollLeft -= 750;
                const leftArrow = document.getElementById('leftArrow');
                const rightArrow = document.getElementById('rightArrow');
                if (container.scrollLeft - 750 <= 0) {
                  leftArrow.style.background = '#DCDCDC';
                  leftArrow.style.cursor = 'not-allowed';
                  leftArrow.style.pointerEvents = 'none';
                } else {
                  leftArrow.style.background = '#ffffff';
                  leftArrow.style.cursor = 'pointer';
                  leftArrow.style.pointerEvents = 'auto';
                }
                rightArrow.style.background = '#ffffff';
                rightArrow.style.cursor = 'pointer';
                rightArrow.style.pointerEvents = 'auto';
              }}
            >
              &lt;
            </button>
            <button
              className="scroll-arrow right"
              id="rightArrow"
              style={{
                position: 'relative',
                top: '0',
                transform: 'none',
                background: '#ffffff',
                color: '#808285',
                border: 'none',
                padding: '10px',
                cursor: 'pointer',
                zIndex: '1',
                borderRadius: '5px',
                fontSize: '18px',
                boxShadow: '0px 4px 4px 0px #0000004D',


                // marginRight: '10px'
              }}
              onClick={() => {
                const container = document.querySelector('.cards-row');
                container.scrollLeft += 750;
                const leftArrow = document.getElementById('leftArrow');
                const rightArrow = document.getElementById('rightArrow');
                leftArrow.style.background = '#ffffff';
                leftArrow.style.cursor = 'pointer';
                leftArrow.style.pointerEvents = 'auto';
                if (container.scrollLeft + 750 + container.clientWidth >= container.scrollWidth) {
                  rightArrow.style.background = '#DCDCDC';
                  rightArrow.style.cursor = 'not-allowed';
                  rightArrow.style.pointerEvents = 'none';
                } else {
                  rightArrow.style.background = '#ffffff';
                  rightArrow.style.cursor = 'pointer';
                  rightArrow.style.pointerEvents = 'auto';
                }
              }}
            >
              &gt;
            </button>
            <script>
              {`
      window.addEventListener('load', () => {
        const leftArrow = document.getElementById('leftArrow');
        leftArrow.style.background = '#DCDCDC';

      });
    `}
            </script>
          </div>
          )} */}

          <div className="cards-row">
            {sections.map((section, idx) => {
              const isActive = location.pathname.includes(
                section.label.toLowerCase()
              );

              return (
                <div
                  key={idx}
                  className={`top-card ${isActive ? "active" : ""}`}
                  onClick={() => handleSectionClick(section)}
                  role="button"
                  tabIndex={0}
                  onKeyDown={(e) => {
                    if (e.key === "Enter" || e.key === " ")
                      handleSectionClick(section);
                  }}
                  aria-pressed={isActive}
                >
                  <div className="top-card-icon">
                    {isActive && section.iconWhite
                      ? section.icon
                      : section.icon}
                  </div>
                  <div className="top-card-text">
                    <span className="top-card-title">
                      {section.displayLabel}
                    </span>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </header>

      <main className="top-cards-content">{children}</main>
    </div>
  );
};

export default SideNavbar;
